import type { CoreInvoice, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

export type GetBookingInvoiceByIdOptions = {
  bookingId: ParameterID
  invoiceId: ParameterID
}

export async function getBookingInvoiceById({
  bookingId,
  invoiceId
}: GetBookingInvoiceByIdOptions): Promise<CoreInvoice> {
  const response = await api.get(
    `/api/saas/me/bookings/${bookingId}/invoices/${invoiceId}`
  )

  return response.data.invoice
}
